import React from "react";
import NewButton from "./NewButton";
import "./PopUpModal.css";

const ApproveTranslationOwner = ({ onCancelClick, onClick }) => {
  return (
    <div className="newPopUpModalWrap">
      <div className="newPopUpModalContainer">
        <h2 className="newPopUpModalTitle">Approve Translation</h2>
        <div className="newPopUpModalContent w-full">
          <div className="newPopUpModalTextWrap">
            <p className="accSingleInvoiceText accSingleInvoiceSubText">Are you sure you want to approve this translation? After this client will review translation</p>

          </div>
        </div>
        <div className="flex flex-col  w-full gap-2">

          <div className="w-full">
            <NewButton
              text={"Approve Translation"}
              width="100%"
              onClick={onClick}
            />
          </div>
          <div className="w-full">
            <NewButton text={"Cancel"} width="100%" onClick={onCancelClick} back icon={false} whiteBtn />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApproveTranslationOwner;
